module.exports = __webpack_public_path__ + "fonts/AveriaSerif-Regular.ea879dd4.ttf";